import React from 'react'
// import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import Loading from './Loading'

export default function EmptySeatResult({ results, eventId, status, isLoading }) {
    const navigate = useNavigate()
    return (<div>
        <br /><br />
        {
            results && <div>
                {
                    isLoading && <div>Loading...</div>
                }
                {
                    !isLoading && <div className='col-12'>
                        {
                            results.length > 0 && <div className='row'>
                                <h5>ที่นั่งว่าง</h5>
                                <br /><br />
                                {
                                    results.map((route, index) => {
                                        return (<div className='col-xs-6 col-sm-6 col-md-4' key={index}>
                                            <div className='card card-body mb-3'>
                                                <div>ชื่อสาย: {route.name}</div>
                                                <div>ที่นั่งว่าง: {route.limit}</div>
                                            </div>
                                        </div>)
                                    })
                                }
                                {
                                    status === 1 && <div className='d-grid gap-2 d-md-flex justify-content-md-end'><div className='btn btn-primary' onClick={() => {
                                        navigate(`/booking/${eventId}`)
                                    }}>จองที่นั่ง</div></div>
                                }
                            </div>

                        }
                    </div>
                }
            </div>
        }
    </div>)
}
